<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-11-18 18:51:12
 * @最后编辑: Please set LastEditors
 * @最后修改时间: 2022-05-05 15:46:48
-->
<template>
  <transition name="mei-message-fade">
    <div
      v-if="show"
      class="mei-message d-flex align-center"
      :style="{ backgroundColor: color }"
      style="z-index: 999999"
    >
      <span class="mei-message-con">{{ text }}</span>
    </div>
  </transition>
</template>

<script type="text/babel">
const typeMap = {
  success: "success",
  info: "info",
  warning: "warning",
  error: "error",
};
export default {
  data() {
    return {
      color: "#18A874",
      show: false,
      text: "",
      type: "success",
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.mei-message {
  position: fixed;
  min-width: 380px;
  border-radius: 4px;
  position: fixed;
  left: 50%;
  /* // top: 20px; */
  bottom: 15px;
  height: 40px;
  transform: translateX(-50%);
  background-color: #edf2fc;
  transition: opacity 0.3s, transform 0.4s;
  overflow: hidden;
  color: #000;
}
/* // .mei-message-icon {
//   display: inline-block;
//   width: 40px;
//   height: 40px;
//   float: left;
// } */
.mei-message-con {
  line-height: 40px;
  height: 40px;
  display: inline-block;
  margin-left: 10px;
  color: #ffffff;
}
.mei-message-fade-enter-active {
  transition: all 0.3s linear;
}
.mei-message-fade-leave-active {
  transition: all 0.3s linear;
}
.mei-message-fade-enter, .mei-message-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
</style>